<template>
  <div class="info-card shadow3">
    <Grid gtc="1fr auto" gap="var(--r-space-sm)" align-items="center" class="opaque-header q-pl-xl q-pr-md">
      <slot name="title">
        <div class="text-subtitle-2 text-secondary-3">{{ title }}</div>
      </slot>

      <DotsIcon v-if="popupItems && popupItems.length" :popup-items="popupItems" @popup-item="$emit($event.name)" />
    </Grid>

    <div class="content bg-white-1 q-px-xl q-py-md">
      <slot />
    </div>
  </div>
</template>

<script>
import DotsIcon from '@/ui/icons/DotsIcon'

export default {
  components: {
    DotsIcon
  },

  props: {
    title: String,
    popupItems: Array
  }
}
</script>

<style lang="scss" scoped>
.info-card {
  border-radius: 2px;
  overflow: hidden;
}
</style>
